export interface ISrtrDataValidation {
    dcAdultGraftSurvival1: boolean,
    dcAdultGraftSurvival3: boolean,
    dcPediatricGraftSurvival1: boolean,
    dcPediatricGraftSurvival3: boolean,
    adultGraftSurvival1: boolean,
    adultGraftSurvival3: boolean,
    pediatricGraftSurvival1: boolean,
    pediatricGraftSurvival3: boolean,
    dcAdultPatientSurvival1: boolean,
    dcAdultPatientSurvival3: boolean,
    dcPediatricPatientSurvival1: boolean,
    dcPediatricPatientSurvival3: boolean,
    adultPatientSurvival1: boolean,
    adultPatientSurvival3: boolean,
    pediatricPatientSurvival1: boolean,
    pediatricPatientSurvival3: boolean,
    srtrSourceDate: boolean,
    centerUnosId: boolean
}